import { render, staticRenderFns } from "./RevisionPanel.vue?vue&type=template&id=87868398&scoped=true&"
import script from "./RevisionPanel.vue?vue&type=script&lang=js&"
export * from "./RevisionPanel.vue?vue&type=script&lang=js&"
import style0 from "./RevisionPanel.vue?vue&type=style&index=0&id=87868398&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "87868398",
  null
  
)

export default component.exports